import React from 'react';
import Dashboard from './containers/Dashboard';

export default [
    {
        path: '/dashboard',
        exact: true,
        component: () => <Dashboard />
    },
];